module.exports = __webpack_public_path__ + "img/2025010401.d4074b30.png";